
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavyRainShowersNightColour as ObiLightningHeavyRainShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-rain-showers-night-colour.js';
 
 
 

 
 export const ObiLightningHeavyRainShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-rain-showers-night-colour',
   elementClass: ObiLightningHeavyRainShowersNightColourElement,
   events: {
     
   }
  });
 
 